export enum LiveGalleryTab {
  PINNED = 'Pinned',
  MEDIA_FILES = 'MediaFiles',
  CAMERA_MANAGEMENT = 'CameraManagement',
  ALERT_RULES = 'AlertRules'
}

export enum LiveGalleryTabView {
  Grid = 'Grid',
  List = 'List'
}
